import React, { useState, useEffect } from 'react';
import './Container.css';
import SearchIcon from '@material-ui/icons/Search'; 

function Container () {

    const [search, setSearch] = useState("Kolkata");
    const [data, setData] = useState([]);   
    const [input, setInput] = useState("");

    /*const fetchWeather = async () => {
         fetch(`https://api.openweathermap.org/data/2.5/weather?q=${search}&appid=8bcb2337f82a28803ee7871588e5f87f`).then(res=>{
             return res.json()
         }).then (json=>{
            console.log(json)
         }).then((res=>{
             setData(res)
         })).catch(err=>{
             console.log(err)
         })
        ;
    }*/

    const fetchWeather = async () => {
        fetch(`https://api.openweathermap.org/data/2.5/weather?q=${search}&appid=8bcb2337f82a28803ee7871588e5f87f`)
        .then(res => res.json())
        .then((res => {console.log(res)}))
        .then((res => {setData(res)}))   
        .catch(err => {console.log(err)}) 
    }

    useEffect(() => {
        fetchWeather();
    }, []);

    let temp = (data?.main?.temp - 273.15).toFixed(2);
    let min_temp = (data?.main?.temp_min - 273.15).toFixed(2);
    let max_temp = (data?.main?.temp_max - 273.15).toFixed(2);

    let img = data?.weather?`https://source.unsplash.com/600x900/?${data?.weather[0]?.main}`:"";

    let d=new Date();
    let date = d.getDate();
    let year = d.getFullYear();
    let month = d.toLocaleString("default", {month: 'long'});
    let day = d.toLocaleString("default", {weekday: 'long'});

    let time = d.toLocaleString([],{
        hour : '2-digit',
        minute : '2-digit',
        second : '2-digit'
    });

    navigator.geolocation.getCurrentPosition(console.log);
    //console.log(fetchWeather)

    return (
        <div className='container' 
             style={{backgroundImage:`url(${img})`}}>
             

            <h1>Weather App</h1>
            <input
                type="text" 
                value={search}
                onChange={(e) => setSearch(e.target.value)}
            />
            <button onClick={fetchWeather}>Search</button>

            <div className='output_container'>
                <h2>{data.name}</h2>
                <p>{day}, {month} {date}, {year}</p>
                <p>{time}</p>
                <p>Cloud icon</p>
                <h1> {temp} &deg;C</h1>
                <p>{data?.weather&&data?.weather[0]?.main}</p>
                <p>{min_temp} | {max_temp}</p>
            </div>
        </div>
    )
}

export default Container;
